<script setup>
import { onBeforeUnmount, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { messageOf } from '@/utils/messages'
const auth = useAuthStore(), route = useRoute(), page = ref(1), total = ref(0), sites = ref([]), company = ref(null)
const busy = ref(false), error = ref('')
let version = 0
onBeforeUnmount(() => { version++ })
async function load() {
  const current = ++version
  busy.value = true; error.value = ''; company.value = null; sites.value = []; total.value = 0
  try {
    if (route.params.slug) {
      const value = await auth.client.request(`/api/b2b/manager/${encodeURIComponent(route.params.slug)}/company`)
      if (current === version) company.value = value
    } else {
      const value = await auth.client.request(`/api/b2b/manager/sites?page=${page.value}&size=20`)
      if (current === version) { sites.value = value.items; total.value = value.total }
    }
  } catch (cause) { if (current === version) error.value = messageOf(cause) }
  finally { if (current === version) busy.value = false }
}
watch(() => route.params.slug, () => { page.value = 1; load() }, { immediate: true })
function move(amount) { page.value += amount; load() }
</script>
<template>
  <div>
    <div class="page-heading"><div><p class="section-kicker">MY COMPANIES</p><h1>담당 기업</h1><p class="muted">소속된 기업과 연수원을 확인하세요.</p></div></div>
    <v-alert v-if="error" role="alert" type="error" variant="tonal" class="mb-5">{{ error }}</v-alert>
    <v-progress-linear v-if="busy" indeterminate color="primary" aria-label="기업 정보 조회 중" />
    <template v-if="route.params.slug">
      <v-btn to="/manager/companies" variant="text" prepend-icon="mdi-arrow-left" class="mb-5">담당 기업 목록</v-btn>
      <section v-if="company" class="panel"><div class="panel-heading"><h2 data-testid="company-name">{{ company.companyNm }}</h2><v-icon color="primary" icon="mdi-domain" /></div><dl class="account-details"><div><dt>연수원</dt><dd>{{ company.siteNm }}</dd></div><div><dt>기업 번호</dt><dd>{{ company.companySeq }}</dd></div><div><dt>연수원 코드</dt><dd data-testid="company-site">{{ company.siteCode }}</dd></div><div><dt>접속 이름</dt><dd>{{ company.slug }}</dd></div><div><dt>허용된 업무</dt><dd>기업·연수원 기본정보 조회</dd></div></dl></section>
    </template>
    <template v-else>
      <section v-if="!busy && !error && !sites.length" class="panel"><h2>담당 기업이 없습니다</h2><p class="muted mb-0">소속된 기업의 연수원이 없습니다. 관리자에게 기업 소속 등록을 요청하세요.</p></section>
      <div class="account-grid"><NuxtLink v-for="site in sites" :key="site.siteCode" :to="`/manager/companies/${encodeURIComponent(site.slug)}`" class="panel"><div class="panel-heading"><h2>{{ site.companyNm }}</h2><v-icon color="primary" icon="mdi-arrow-right" /></div><p>{{ site.siteNm }}</p><p class="muted mb-0">{{ site.siteCode }} · {{ site.slug }}</p></NuxtLink></div>
      <div v-if="total > 20" class="d-flex justify-center align-center ga-4 mt-6"><v-btn variant="text" :disabled="busy || page === 1" @click="move(-1)">이전</v-btn><span>{{ page }} / {{ Math.ceil(total / 20) }}</span><v-btn variant="text" :disabled="busy || page * 20 >= total" @click="move(1)">다음</v-btn></div>
    </template>
  </div>
</template>
